
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M24.25 30.197L5.266 37.164c-.695.262-1.198-.066-1.198-1.285 0-12.508 12.726-12.647 20.182-10.515m-.01-.916V3.854c-.006-.744.47-1.089 1.618-.68 11.898 4.216 8.053 15.142 4.774 21.274m.034.53l19.191 8.84c.673.3.81.884-.053 1.754-7.229 7.303-14.798 2.014-19.172-3.17M52 52H3"}}),_c('path',{attrs:{"d":"M24.24 24.428a3.196 3.196 0 116.392 0v27.564H24.24V24.428z"}})])])
          )
        }
      }
    